export default "__VITE_ASSET__eb747026__"